import api from './APIService';

class OrganizationService {
	getOrganizations() {
		return api.fetch({ method: 'get', path: '/livelaps/organization' });
	}
	getOrganizationsByIds(ids) {
		return api.fetch({ method: 'get', path: '/livelaps/organization/by-ids/' + ids });
	}
	getOrganizationByPromoterId(promoterId) {
		return api.fetch({ method: 'get', path: '/participant/getOrganizationByPromoterId/' + promoterId});
	}
	getOrganizationByEventId(eventId) {
		return api.fetch({ method: 'get', path: '/participant/getOrganizationByEventId/' + eventId });
	}
	getOrganizationById(id) {
		return api.fetch({ method: 'get', path: '/livelaps/organization/' + id });
	}
	getOrganizationPromoters(organizationId) {
		return api.fetch({ method: 'get', path: '/participant/organization-promoters/' + organizationId });
	}
	getUrlD14AMA() {
		return api.fetch({ method: 'get', path: '/participant/organization/available-d14-url/' });
	}
	validateD14AMA(data){
		return api.fetch({ method: 'post', path: '/participant/membership/validate-d14/', data });
	}
	getOrganizationsAvailableForAma(){
		return api.fetch({ method: 'get', path: '/participant/organization/available-organizations-for-ama/' });
	}
}

export default new OrganizationService();
